import { Config } from "@forgerock/javascript-sdk";
import useLanguageMiddleware from "src/customHooks/useLanguageMiddleware";
import idTokenMiddleware from "src/customHooks/idTokenMiddleware";
import useForceAuthMiddleware from "src/customHooks/useForceAuthMiddleware";

// This function gets called in every page that connects to a tree
export function configure(
  clientId = process.env.REACT_APP_CONFIG_CLIENT_ID,
  redirect = process.env.REACT_APP_CONFIG_REDIRECT_URI,
  scope = process.env.REACT_APP_CONFIG_SCOPE,
  journey = process.env.REACT_APP_CONFIG_TREE,
  realm = process.env.REACT_APP_CONFIG_REALM,
  baseUrl = process.env.REACT_APP_CONFIG_URL,
  timeout = process.env.REACT_APP_CONFIG_TIMEOUT,
  middleware = useLanguageMiddleware,
  idToken = idTokenMiddleware,
  forceAuth = useForceAuthMiddleware
) {
  return Config.set({
    clientId: `${clientId}`,
    middleware: [middleware, idToken, forceAuth],
    redirectUri: `${redirect ?? "dashboard"}`,
    scope: `${scope}`,
    serverConfig: {
      baseUrl: `${baseUrl}`,
      timeout: `${timeout}`,
    },
    realmPath: `${realm}`,
    tree: `${journey}`,
  });
}

export function getConfiguration() {
  let currentConfiguration = Config.get();
  return currentConfiguration;
}
